module.exports = __webpack_public_path__ + "static/media/java.0dc7c23a.svg";